import AbstractEntity from "../AbstractEntity";

export default class LegalDocumentTemplate extends AbstractEntity {
    _id;
    _name;
    _explanation;
    _periodValidity;
    _bannedIfNotProvided;
    _blockingBilling;
    _enable;
    _allWorksConcerned;
    _worksConcernedId;

    getId() {
        return this._id;
    }

    getName() {
        return this._name;
    }

    getExplanation() {
        return this._explanation;
    }

    getPeriodValidity() {
        return this._periodValidity;
    }

    isBannedIfNotProvided() {
        return this._bannedIfNotProvided;
    }

    isBlockingBilling() {
        return this._blockingBilling;
    }

    isEnable() {
        return this._enable;
    }

    isAllWorksConcerned() {
        return this._allWorksConcerned;
    }

    getWorksConcernedId() {
        return this._worksConcernedId;
    }


    getClassName() {
        return "legal_document_template";
    }
}